import React from 'react';
import { useNavigate } from 'react-router-dom';
import { CheckCircle, XCircle, DollarSign, FileText } from 'lucide-react';

const pendingItems = [
  {
    id: 1,
    title: 'Reparación Elevador',
    requestor: 'Admin Torres',
    amount: '$15,000',
    type: 'expense',
    date: '2026-03-18',
  },
  {
    id: 2,
    title: 'Pintura Fachada',
    requestor: 'Admin García',
    amount: '$45,000',
    type: 'project',
    date: '2026-03-15',
  },
  {
    id: 3,
    title: 'Mantenimiento Jardines',
    requestor: 'Admin López',
    amount: '$3,500',
    type: 'expense',
    date: '2026-03-10',
  },
];

export function PendingApprovalsWidget() {
  const navigate = useNavigate();

  return (
    <div className="space-y-3">
      <div className="flex items-center justify-between pb-2 border-b border-gray-100">
        <span className="text-sm text-gray-500">Total pendiente:</span>
        <span className="text-lg font-bold text-orange-600">{pendingItems.length} items</span>
      </div>

      {pendingItems.map((item) => (
        <div key={item.id} className="p-3 bg-gray-50 rounded-lg">
          <div className="flex items-start justify-between gap-2">
            <div className="flex-1 min-w-0">
              <div className="flex items-center gap-2">
                {item.type === 'expense' ? (
                  <FileText className="w-4 h-4 text-orange-500" />
                ) : (
                  <DollarSign className="w-4 h-4 text-green-500" />
                )}
                <p className="font-medium text-sm text-gray-900 truncate">{item.title}</p>
              </div>
              <p className="text-xs text-gray-500 mt-1">{item.requestor} • {item.date}</p>
            </div>
            <span className="font-semibold text-gray-900 text-sm">{item.amount}</span>
          </div>

          <div className="flex items-center gap-2 mt-3">
            <button className="flex-1 flex items-center justify-center gap-1 py-1.5 bg-green-100 text-green-700 rounded-lg text-xs font-medium hover:bg-green-200 transition-colors">
              <CheckCircle className="w-3 h-3" />
              Aprobar
            </button>
            <button className="flex-1 flex items-center justify-center gap-1 py-1.5 bg-red-100 text-red-700 rounded-lg text-xs font-medium hover:bg-red-200 transition-colors">
              <XCircle className="w-3 h-3" />
              Rechazar
            </button>
          </div>
        </div>
      ))}

      <button
        onClick={() => navigate('/morosos')}
        className="w-full py-2 text-sm font-medium text-[#36CCD8] hover:text-[#2DB8C4] hover:bg-[#36CCD8]/5 rounded-lg transition-colors"
      >
        Ver todos los pendientes →
      </button>
    </div>
  );
}

export default PendingApprovalsWidget;
